import type { IFieldOptions } from '@axo/form/feature/form-input';
import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { TextFieldUI } from '@axo/form/feature/form-input/TextField/TextFieldUI';
import { Purpose } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { purposeOptions } from '../../config/globals';
import type { PurposeFormGroupData } from '../../FormData.dk.types';
import { otherPurposeFieldOptions } from './config';

export const PurposeFormGroup = () => {
  const { t } = useTranslation();

  const { watch, setValue, register } = useFormContext();

  const [loanPurpose, dropdownPurpose] = watch([
    'LoanApplication/Purpose',
    'Frontend/DropdownPurpose',
  ]);

  const purposeFieldOptions: IFieldOptions = useMemo(
    () => ({
      registerOptions: {
        required: 'error.required',
        shouldUnregister: false,
        onChange: (event) => {
          setValue('LoanApplication/Purpose', event.target.value);
        },
      },
    }),
    [setValue]
  );

  const askWrittenPurpose = loanPurpose === Purpose.Other;

  useEffect(() => {
    if (!dropdownPurpose) return;

    if (dropdownPurpose !== loanPurpose) {
      setValue('LoanApplication/Purpose', dropdownPurpose);
    }
  }, [dropdownPurpose, loanPurpose, setValue]);

  return (
    <>
      <input
        type="hidden"
        {...register('LoanApplication/Purpose', {
          shouldUnregister: false,
        })}
      />

      <DropdownFieldUI<PurposeFormGroupData>
        name="Frontend/DropdownPurpose"
        label={t('Purpose.label')}
        placeholder={t('placeholder')}
        data-testid="loan-purpose-dropdown"
        options={purposeOptions}
        {...purposeFieldOptions}
      />

      {askWrittenPurpose && (
        <TextFieldUI<PurposeFormGroupData>
          name="LoanApplication/OtherPurpose"
          label={t('Purpose.label', { context: 'written' })}
          data-testid="loan-purpose-input"
          {...otherPurposeFieldOptions}
        />
      )}
    </>
  );
};
